export const logout = async () => {

    localStorage.removeItem('apiKey');
    localStorage.removeItem('isLogged');
  
    try {
      const success = await caches.delete('pwa-cache-v1');
      console.log(success ? 'Cache cleared.' : 'Could not clear cache.');
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
    
    window.location.href = '/';
  };
  